const subprefeituras_centros = {
    
    "Subprefeitura Da Barra Da Tijuca": {
        "lat": -22.9853849,
        "lng": -43.3994958
    },
    "Subprefeitura Da Grande Bangu": {
        "lat": -22.8755154,
        "lng": -43.4055447
    },
    "Subprefeitura Da Grande Tijuca": {
        "lat": -22.9526463,
        "lng": -43.211586
    },
    "Subprefeitura Da Zona Norte": {
        "lat": -22.8508388,
        "lng": -43.286871
    },
    "Subprefeitura Da Zona Oeste": {
        "lat": -22.922329,
        "lng": -43.5977454
    },
    "Subprefeitura Da Zona Sul": {
        "lat": -22.9530818,
        "lng": -43.2180822
    },
    "Subprefeitura De Ilhas": {
        "lat": -22.8388679,
        "lng": -43.1692036
    },
    "Subprefeitura De Jacarepaguá": {
        "lat": -22.9415667,
        "lng": -43.3144605
    },
    "Subprefeitura Do Centro": {
        "lat": -22.9230818,
        "lng": -43.2180822
    }
}
export default subprefeituras_centros;